<template>  
        <div class="row justify-content-center">
            <div class="col-md-8 wizard-container">
                <div class="wizard">
                     
                        <div class="connecting-line connecting-line-width"></div>
                        <ul class="nav nav-tabs" role="tablist">
                            <li role="presentation" class='step-tab' :class="{ 'active': status >= 1 }">
                                <p class="bid-status-title">
                                    Abertura de demanda
                                    <span v-if="stAbertaDth != ''">
                                        <br>{{ moment(stAbertaDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step1" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Abertura de demanda</span>
                                    </span>
                                </a>
                            </li>
                            <li role="presentation" class='step-tab' :class="{ 'active': status >= 2 }">
                                <p class="bid-status-title">Seleção de Peritos
                                    <span v-if="stSelecaoDth != ''">
                                        <br>{{ moment(stSelecaoDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step2" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Seleção de Peritos</span>
                                    </span>
                                </a>
                            </li>
                            <li role="presentation" class='step-tab' :class="{ 'active': status >= 3 }">
                                <p class="bid-status-title">Proposta Aceita
                                    <span v-if="stPropostaAceitaDth != ''">
                                        <br>{{ moment(stPropostaAceitaDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step3" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Proposta Aceita</span>
                                    </span>
                                </a>
                            </li>
                            <li role="presentation" class='step-tab' :class="{ 'active': status >= 4 }">
                                <p class="bid-status-title">Pagamento para Seuperito
                                    <span v-if="stPagoDth != ''">
                                        <br>{{ moment(stPagoDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step4" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Pagamento para Seuperito</span>
                                    </span>
                                </a>
                            </li>
                            <li v-if='contractor' role="presentation" class='step-tab' :class="{ 'active': status >= 5 }">
                                <p class="bid-status-title">Perícia Entregue
                                    <span v-if="stPericaEntregueDth != ''">
                                        <br>{{ moment(stPericaEntregueDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step5" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Perícia Entregue</span>
                                    </span>
                                </a>
                            </li>
                            <li v-if='contractor' role="presentation" class='step-tab' :class="{ 'active': status >= 6, 'active_red': status == 7 || status == 9}">
                                <p class="bid-status-title">Perícia Avaliada
                                    <span v-if="stConcluidoDth != ''">
                                        <br>{{ moment(stConcluidoDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step5" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Perícia Avaliada</span>
                                    </span>
                                </a>
                            </li>
                            <li v-if='contractor' role="presentation" class='step-tab' :class="{ 'active': status == 8 }">
                                <p class="bid-status-title">Pagamento para Perito Contratado
                                    <span v-if="stPeritoPagoDth != ''">
                                        <br>{{ moment(stPeritoPagoDth).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </p>
                                <a aria-controls="step6" role="tab">
                                    <span class="round-tab tooltip">
                                        <span class="tooltips">Pagamento para Perito Contratado</span>
                                    </span>
                                </a>
                            </li>
                        </ul> 
    
                </div>
            </div>
        </div> 
</template>

<script>

import moment from 'moment';

export default {
    props:{
        bid: {
            type: Object,
            required: true,
        },
        contractor: false,
    },
    data() {
        return {
            moment: moment,
            status: 1,
            statuses: [],
            stAbertaDth: "",
            stSelecaoDth: "",
            stPropostaAceitaDth: "",
            stPagoDth: "",
            stPericaEntregueDth: "", 
            stConcluidoDth: "", 
            stNaoConcluidoDth: "", 
            stPeritoPagoDth: "", 
            stEmDisputaDth: "",
        };
    }, 
    methods: {
    },
    mounted() {

        let elements = document.querySelectorAll('.step-tab');
        let elementWidth = 100 / elements.length;

        elements.forEach((element) => {
            element.style.width = elementWidth+'%';
        });

        switch(this.bid.status.status){

            case 'Aberta': this.status = 1; break;
            case 'Seleção': this.status = 2; break;
            case 'Proposta Aceita': this.status = 3; break;
            case 'Pago': this.status = 4; break;
            case 'Pericia Entregue': this.status = 5; break;
            case 'Concluido': this.status = 6; break;
            case 'Não Concluido': this.status = 7; break;
            case 'Perito Pago': this.status = 8; break;
            case 'Em Disputa': this.status = 9; break;
            
        }

        axios.get(`/demanda/statuses/${this.bid.id}`)
            .then(({data}) => {

                if ( data.length > 0 ) {
                    this.statuses = data;

                    this.statuses.forEach((value, index) => {
                        switch(value.status)
                        {
                            case 'Aberta': 
                                this.stAbertaDth = value.created_at;
                                break;
                            case 'Seleção': 
                                this.stSelecaoDth = value.created_at;
                                break;
                            case 'Proposta Aceita': 
                                this.stPropostaAceitaDth = value.created_at;
                                break;
                            case 'Pago': 
                                this.stPagoDth = value.created_at;
                                break;
                            case 'Pericia Entregue': 
                                this.stPericaEntregueDth = value.created_at;
                                break;
                            case 'Concluido': 
                                this.stConcluidoDth = value.created_at;
                                break;
                            case 'Não Concluido': 
                                this.stNaoConcluidoDth = value.created_at;
                                break;
                            case 'Perito Pago': 
                                this.stPeritoPagoDth = value.created_at;
                                break;
                            case 'Em Disputa': 
                                this.stEmDisputaDth = value.created_at;
                                break;
                        }
                    });
                }
                else {
                    console.error('Problemas com os statuses');
                }
            });
    }
}
</script>

<style>   
    
    .wizard p {
        text-align: center;
        height: 40px;
        font-weight: 600;
    }

    .wizard-container {
        width: 100%;
    }
    
    .connecting-line-width {
        top: 68% !important;
    }

    .connecting-line {
        height: 2px;
        background: #e0e0e0;
        position: absolute;
        width: 85%;
        margin: 0 auto;
        left: 0;
        right: 0;
        z-index: 1;
    } 

    span.round-tab {
        width: 30px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        border-radius: 50%;
        background: #fff;
        z-index: 1;
        position: absolute;
        left: 0;
        text-align: center;
        font-size: 16px;
        color: #0e214b;
        font-weight: 500;
        border: 1px solid #ddd;
    }

    .wizard li.active span.round-tab {
        background: #0db02b;
        color: #fff;
        border-color: #0db02b;
    }  

    .wizard li.active_red span.round-tab {
        background: #b00d0d;
        color: #fff;
        border-color: #b00d0d;
    }  

    .wizard li:after {
        content: " ";
        position: absolute;
        left: 46%;
        opacity: 0;
        margin: 0 auto;
        bottom: 0px; 
        transition: 0.1s ease-in-out;
    }

    .wizard .nav-tabs > li a {
        width: 30px;
        height: 30px;
        margin: 20px auto;
        border-radius: 100%;
        padding: 0;
        background-color: transparent;
        position: relative;
        top: 0;
    }

    .wizard .nav-tabs > li a i{
        position: absolute;
        top: -15px;
        font-style: normal;
        font-weight: 400;
        white-space: nowrap;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: 700;
        color: #000;
    }

    .wizard .nav-tabs > li a:hover {
        background: transparent;
        cursor: default;
    } 

    .nav-tabs {
        border: 0;
    } 
    
    @media (min-width: 768px){
    
        .tooltips{
            display: none !important;
        }

    }

    @media (max-width: 767px){
        .bid-status-title {
            display: none;
        }
        
        .connecting-line-width{
            top: 55% !important;
        }

        .sign-content h3{
            font-size: 40px;
        }

        .wizard .nav-tabs > li a i{
            display: none;
        } 

    }

</style>